import React, { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import _ from "lodash";

import { GET_FAVORITES } from "../../schemas/favorite";
import { GET_PROGRAMS_BY_IDS_AND_LANGS } from "../../schemas/program";
import { FavoriteProgramGrid } from "./FavoriteProgramGrid";
import { FavoriteProgramCard } from "./FavoriteProgramCard"
import { Row } from "react-bootstrap";
import SearchBar from "../SearchBar";
import "./style.scss";


export const ProfileFavorites = ({ labels }) => {
  const [shape, setShape] = useState( Utils.isMobile() ? "grid" : "list");
  const labelsOfSearchResultsWidget = labels.SearchResults.labels;
  const [results, setResults] = useState([]);
  const [getFavorites, { loading, data: favoriteData }] = useLazyQuery(GET_FAVORITES, {
    fetchPolicy: "no-cache",
  });
  const [getProgramsByIdsAndLangs, { loading: loadingProgram, data: dataProgram }] = useLazyQuery(
    GET_PROGRAMS_BY_IDS_AND_LANGS,
    {
      fetchPolicy: "no-cache",
    }
  );

  const orderProgramsByNidOrder = (unOrderedPrograms, nidOrder) => {
    let orderedPrograms = [];
    let program;
    let tracksInPrograms = matchTracksToPrograms(); 
    let tracksIdInPrograms = matchTracksIdToPrograms();
    nidOrder.forEach(nid => {
      program = unOrderedPrograms.find(element => element.nid == nid);
      if (program) {
        program.track = tracksInPrograms[nid];
        program.trackId = tracksIdInPrograms[nid];
        orderedPrograms.push(program);
      }
    });
    return orderedPrograms;
  }

  const divideFavoriteProgramsByLang = () => {
    const heNids = [];
    const enNids = [];
    favoriteData.getFavorites.body.forEach(program => {
      if (program.langcode === "he") {
        heNids.push(program.nid);
      } else {
        enNids.push(program.nid);
      }
    })
    return [heNids, enNids];
  }

  const matchTracksToPrograms = () => {
    const tracksInPrograms = {};
    favoriteData.getFavorites.body.forEach(program => {
      tracksInPrograms[program.nid] = program.track;
    })
    return tracksInPrograms;
  }

  const matchTracksIdToPrograms = () => {
    const tracksIdInPrograms = {};
    favoriteData.getFavorites.body.forEach(program => {
      tracksIdInPrograms[program.nid] = program.trackId;
    })
    return tracksIdInPrograms;
  }

  useEffect(() => {
    getFavorites();
  }, []);                       

  useEffect(() => {
    if (!loading && favoriteData) {
      const [heNids, enNids] = divideFavoriteProgramsByLang();
      getProgramsByIdsAndLangs({
        variables: {
          heNids: heNids,
          enNids: enNids,
        },
      });
    }
  }, [loading, favoriteData]);

  //correct the order of the programs by our weight and then set the results (nidOrder are our nids in the correct order by weight)
  useEffect(() => {
    if (!loadingProgram && dataProgram) {
      const unOrderedPrograms = dataProgram.getProgramsByIdsAndLangs.results;
      const nidOrder = favoriteData.getFavorites.body.map(program => program.nid);
      const orderedPrograms = orderProgramsByNidOrder(unOrderedPrograms, nidOrder);
      setResults(orderedPrograms);
    }
  },[loadingProgram, dataProgram])

  const changeView = ( shape ) => {
    setShape(shape);
  };
  
  return (
    <div className="profile-favorites">
      <h2>{labels.title}</h2>
      <Row className="wrapper-header  justify-content-between">
        <div className="description col-md-11 p-0">{labels.description}</div>
        { !Utils.isMobile() && (
          <div className="shapes col-md-1 row">
            <div
              role="button"
              className="img-2"
              tabIndex="0"
              onClick={(e) => changeView("grid")}
              aria-label={labels.grid_view}
            ></div>
            <div
              role="button"
              tabIndex="0"
              className="img-1"
              onClick={(e) => changeView("list")}
              aria-label={labels.list_view}
            ></div>
          </div>
        )}
      </Row>
      { results.length == 0 ? (
        <div className="wrapper">
        <a href={labels.contact}  target="_blank">
          <div className="label_1">{labels.label_1}</div>
          <div className="label_2">{labels.label_2}</div>
        </a>
          <SearchBar labels={labels.SearchBar.labels} is_profile_page={true}></SearchBar>
        </div>
      ) : shape == "list" ? (
        results.map((program, index) => (
          <FavoriteProgramCard
            favoriteData={favoriteData}
            key={`${program.nid}_${program.langcode}`}
            item={program}
            getAllFavorites={getFavorites}
            labels={labels}
            searchResultsLabels={labelsOfSearchResultsWidget}
            notes={Utils.getNotes(program.nid, favoriteData)}
            trackId={program.trackId}
          />
        ))
      ) : (
        <Row className="search-results-shape">
          {results.map((program, index) => (
            <FavoriteProgramGrid
              favoriteData={favoriteData}
              key={program.nid}
              item={program}
              getAllFavorites={getFavorites}
              labels={labels}
              searchResultsLabels={labelsOfSearchResultsWidget}
              notes={Utils.getNotes(program.nid, favoriteData)}
              trackId={program.trackId}
            />
          ))}
        </Row>
      )}
    </div>
  );
};
